import React from "react";
import styled, { keyframes } from "styled-components";

import Skeleton from "../../components/layout/skeleton";
import { colors, breakpoints } from "../../../theme";
import { Flex } from "../../styles/global-styles";
import {
  BlogContainer,
  BlogImageWrapper,
  BlogContentContainer,
  BlogContent,
} from "../../components/BlogCard/styles";
import { BlogPostsGrid } from "./styles";

const pulse = keyframes`
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
`;

const SkeletonImage = styled(BlogImageWrapper)`
  background-color: ${colors.grey.medium};
  animation: ${pulse} 1.4s ease-in-out infinite;
`;

const CategoryBone = styled(Skeleton)`
  display: none;
  margin-bottom: 8px;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: block;
    height: 14px;
    width: 36%;
  }
`;

const TitleBone = styled(Skeleton)`
  height: 14px;
  margin-bottom: 6px;

  @media only screen and (min-width: 600px) {
    height: 16px;
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 20px;
  }
`;

const MetaBone = styled(Skeleton)`
  height: 12px;
  width: 55%;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: 14px;
    width: 50%;
  }
`;

const ReadMoreBone = styled(Skeleton)`
  display: none;
  height: 32px;
  width: 96px;
  border-radius: 18px;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    display: block;
  }
`;

const BlogCardSkeleton = ({ variant = "normal" }) => (
  <BlogContainer variant={variant} style={{ cursor: "default" }}>
    <SkeletonImage variant={variant} />
    <BlogContentContainer variant={variant}>
      <BlogContent>
        <CategoryBone />
        <TitleBone width="92%" />
        <TitleBone width="70%" />
      </BlogContent>
      <Flex spaceBetween style={{ width: "100%" }}>
        <MetaBone />
        <ReadMoreBone />
      </Flex>
    </BlogContentContainer>
  </BlogContainer>
);

const BlogCardsSkeleton = ({ count = 3, variant = "normal" }) => (
  <BlogPostsGrid variant={variant} aria-hidden>
    {Array.from({ length: count }, (_, index) => (
      <BlogCardSkeleton key={index} variant={variant} />
    ))}
  </BlogPostsGrid>
);

export default BlogCardsSkeleton;
